import React from "react";
import AccessCardFormFields from "components/AccessCardFormFields";
import { createOne } from "actions/accessCard";
import { fetchAll } from "actions/user";
import { connect } from "react-redux";
import * as R from "ramda";
import { withRouter } from "react-router-dom";

const mapDispatchToProps = {
  createOne,
  fetchAll
};

const mapStateToProps = state => ({
  isUpdating: state.reader.isUpdating,
  users: state.user.byId,
  isFetching: state.user.isFetching
});

class AdminAccessCardCreate extends React.Component {
  state = {
    accessCard: {
      orderer: "Administrator",
      name: "",
      access_levels: [""],
      user_id: ""
    }
  };

  componentWillMount() {
    this.props.fetchAll();
  }

  handleSubmit = event => {
    event.preventDefault();
    const { createOne, history } = this.props;
    const { accessCard } = this.state;

    const data = {
      ...accessCard,
      access_levels: accessCard.access_levels.filter(r => !!r)
    };

    createOne(data).then(data => {
      history.push("/admin/accesscard/list");
    });
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  render() {
    const { users, isFetching } = this.props;
    const items = Object.keys(users).map(id => users[id]);
    if (!(!isFetching && items)) {
      return null;
    }
    return (
      <form onSubmit={this.handleSubmit}>
        <div style={{ margin: "0 auto" }}>
          <AccessCardFormFields
            accessCard={this.state.accessCard}
            onChange={this.handleChange}
            users={users}
            user={users[this.state.accessCard.user_id]}
          />
        </div>
        <div className="form-group">
          <button id="submit" name="submit" className="btn btn-primary">
            Legg til adgangskort
          </button>
        </div>
      </form>
    );
  }
}

export default R.compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AdminAccessCardCreate);



// WEBPACK FOOTER //
// ./src/components/AdminAccessCardCreate.js